import { createFileRoute } from "@tanstack/react-router";
import {
  WorkOrderList,
  WorkOrderListContainer,
  WorkOrderListContent,
  WorkOrderListFilterButton,
  WorkOrderListHeader,
  WorkOrderListSearchBar,
  WorkOrderListSearchRow,
  WorkOrderListSort,
  WorkOrderListTab,
} from "@/components/domain/WorkOrder/Mobile/WorkOrderList/WorkOrderList.tsx";
import { authGuardWithPermissions } from "@/utils/authGuard.ts";
import type { RouterContextType } from "@/api/permissions/permissions.api.ts";

export const Route = createFileRoute("/_authenticated/mobile/work-order/")({
  component: ListWorkOrderMobilePage,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function ListWorkOrderMobilePage() {
  return (
    <div style={{ width: "100%", minHeight: "100vh", height: "100%", overflow: "hidden" }}>
      <WorkOrderList>
        <WorkOrderListHeader>
          <WorkOrderListTab />
        </WorkOrderListHeader>
        <WorkOrderListContainer>
          <WorkOrderListSearchRow>
            <WorkOrderListSearchBar />
            <WorkOrderListFilterButton />
          </WorkOrderListSearchRow>
          <WorkOrderListSort />
          <WorkOrderListContent />
        </WorkOrderListContainer>
      </WorkOrderList>
    </div>
  );
}
